module.exports = __webpack_public_path__ + "static/media/LogoHorizontal-White.af5861ce.jpg";